import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL

class EmailApi {
  getAllEmailTemplates(queryConfig) {
    return axios.get(`${baseUrl}/email/all`, queryConfig)
  }

  updateEmailTemplate(id, data, config) {
    return axios.put(`${baseUrl}/email/${id}`, data, config)
  }

  getEmailTemplateById(id, config) {
    return axios.get(`${baseUrl}/email/${id}`, config)
  }

  deleteEmailTemplate(id, config) {
    return axios.delete(`${baseUrl}/email/${id}`, config)
  }

  addEmailTemplate(data, config) {
    return axios.post(`${baseUrl}/email/add`, data, config)
  }
}

export default new EmailApi()
